import React from "react";
import girlBookImg from "../../assets/girlwithbook.svg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { FaArrowRight } from "react-icons/fa6";
import { FaArrowLeft } from "react-icons/fa";
import PreLoadingImages from "../custom/PreLoadingImages";
import { aboutImages } from "../../utils/constants";

const colColumns = [
  { bgColor: "#722A8A", title: "Free & Structured Learning" },
  { bgColor: "#B2529D", title: "Tried & Tested" },
  { bgColor: "#8F3D94", title: "Backed by Pedagogs" },
  { bgColor: "#76538C", title: "Practiced Worldwide" },
];

const colColumns2 = [
  { bgColor: "#544B99", title: "Holistic Development " },
  { bgColor: "#537BB0", title: "Assured Learning Outcomes" },
  { bgColor: "#8F3D94", title: "Research based" },
  { bgColor: "#76538C", title: "Best practices " },
];

const ColContainer = () => {
  const NextArrow = ({ onClick }) => (
    <div
      className="absolute bottom-[-25px] z-[15] right-[140px] md:right-[330px] lg:right-[150px] xl:right-[220px] h-5 w-5 border border-black rounded-full cursor-pointer"
      onClick={onClick}
    >
      <FaArrowRight />
    </div>
  );

  const PrevArrow = ({ onClick }) => (
    <div
      className="absolute bottom-[-25px] z-[15] left-[140px] md:left-[330px] lg:left-[150px] xl:left-[220px] h-5 w-5 border border-black rounded-full cursor-pointer"
      onClick={onClick}
    >
      <FaArrowLeft />
    </div>
  );

  const pedagogiesSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true,
    centerMode: true,
    centerPadding: "0px",
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const images = [
      aboutImages?.mobileMissionImg,
      aboutImages?.mobileVisionImg,
      aboutImages?.mobileSchoolImg,
      aboutImages?.tabMissionImg,
      aboutImages?.tabVisionImg,
      aboutImages?.tabSchoolImg,
    ];

  return (
    <div className="flex min-h-[30rem] lg:flex-row lg:py-0 py-[2rem] flex-col lg:gap-10 gap-[60px] lg:px-[10%] bg-[#e4f7ff]  justify-between items-center">
      <PreLoadingImages images={images} />
      <div className="flex  sm:gap-[2rem]">
        <img
          src="/curroflove.svg"
          layout="fit"
          width={350}
          alt="curroflove"
          className="sm:h-[200px] h-[120px]"
        />
        <img
          src={girlBookImg}
          layout="fit"
          width={220}
          height={200}
          alt="girlwithbook"
          className="lg:flex hidden"
        />
      </div>
      <Slider
        {...pedagogiesSettings}
        className="w-[100%] lg:w-[45%] pb-3 sm:pb-6 lg:mb-0 mb-[1rem]"
      >
        <PedgagogiesContainer cols={colColumns} />
        <PedgagogiesContainer cols={colColumns2} />
      </Slider>
    </div>
  );
};

export default ColContainer;

const PedgagogiesContainer = ({ cols }) => {
  return (
    <div className="grid font-Lato grid-cols-2 sm:grid-cols-2 p-1 sm:p-3 sm:h-full gap-2 sm:gap-4">
      {cols?.map((item, index) => (
        <p
          key={index}
          className=" flex justify-center items-center font-Lato font-bold leading-8 text-white text-center h-[90px] sm:h-[150px] border text-lg sm:text-[28px] border-white rounded-xl sm:rounded-[40px] px-2"
          style={{ background: item?.bgColor }}
        >
          <p className="p-0 m-0">{item?.title}</p>
        </p>
      ))}
    </div>
  );
};
